import { FETCH_COMPETITIONS, SET_COMPETITION_ENTRIES, ADD_COMPETITION_ENTRY } from 'Redux/ducks/competition';

const initialState = {
  competitions: [],
  competitionEntries: [],
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_COMPETITIONS:
      return { ...state, competitions: action.payload };
    case SET_COMPETITION_ENTRIES:
      return { ...state, competitionEntries: action.payload };
    case ADD_COMPETITION_ENTRY: {
      const { competitionId, entryDate } = action.payload;
      if (state.competitionEntries.some(e => e.competitionId === competitionId)) return state;
      return {
        ...state,
        competitionEntries: [...state.competitionEntries, { competitionId, entryDate }],
      };
    }
    default:
      return state;
  }
}
